import React from 'react';
import TableItem from '../Table';
import LineChartItem from '../LineChartItem';

interface ProfitLossTabProps {
  companyData: any;
}

export default function ProfitLossTab({ companyData }: ProfitLossTabProps) {
  if (!companyData) return null;

  return (
    <div className="space-y-8 min-w-0">
      {/* P&L Table */}
      {companyData.profit_n_loss && (
        <section className="bg-white rounded-xl border border-slate-200 p-6 overflow-hidden">
          <h3 className="text-lg font-semibold text-slate-900 mb-4">Profit and Loss Statement</h3>
          <TableItem table={companyData.profit_n_loss} head_bold={true} bold_column_indexes={[0]} />

          {companyData.profit_n_loss_chart_data && (
            <div className="mt-6">
              <LineChartItem
                name="Profit and Loss"
                x_axis={companyData.profit_n_loss_chart_data.x_axis}
                data={companyData.profit_n_loss_chart_data.data}
                order={companyData.profit_n_loss_chart_data.order}
              />
            </div>
          )}
        </section>
      )}

      {/* Profitability Analysis */}
      {companyData.profitability_percents && (
        <section className="bg-white rounded-xl border border-slate-200 p-6 overflow-hidden">
          <h3 className="text-lg font-semibold text-slate-900 mb-4">Profitability Analysis</h3>
          <TableItem table={companyData.profitability_percents} head_bold={true} bold_column_indexes={[0]} />

          {companyData.profitability_percents_chart_data && (
            <div className="mt-6">
              <LineChartItem
                name="Profitability (%)"
                x_axis={companyData.profitability_percents_chart_data.x_axis}
                data={companyData.profitability_percents_chart_data.data}
                order={companyData.profitability_percents_chart_data.order}
              />
            </div>
          )}

          {companyData.profitability_totals && (
            <div className="mt-6">
              <h4 className="text-base font-medium text-slate-700 mb-3">Totals</h4>
              <TableItem table={companyData.profitability_totals} head_bold={true} bold_column_indexes={[0]} />
              {companyData.profitability_totals_percents && (
                <TableItem table={companyData.profitability_totals_percents} head_bold={true} bold_column_indexes={[0]} />
              )}
            </div>
          )}
        </section>
      )}
    </div>
  );
}
